// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"DealerLocatorNonInstantAccessWarning_mainContainer__3A4ET","wording":"DealerLocatorNonInstantAccessWarning_wording__5JB6N"};